module.exports = __webpack_public_path__ + "img/vehicle.94f3cb59.svg";